export type REVENUE_TARGET_TYPES = 'INSTITUTION' | 'ORGANIZATON';

export type REVENUE_FILTER = 'INVOICED' | 'TO_BE_INVOICED';

export type BucketType = 'totals';
export const DEFAULT_FIRST_MONTH = '0'; // January zero indexed
export const DEFAULT_NUMBER_OF_MONTHS = '12';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const FIRST_DAY_OF_YEAR = '01-01';
export const LAST_DAY_OF_YEAR = '12-31';
